<template>
    <div class="vs-col m-auto float-none vs-xs- vs-sm-12 vs-lg-11 pt-6" vs-type="flex" vs-justify="center" vs-align="center">
        <div class="form-container">
            <template v-for="(taxYear, index) in value">
                <!-- <label class="form_label">Wages received  {{ taxYear.year }} as per W2</label> -->
                <div class="wage_documents_sec">
                    <label class="small-header">Wages received  <strong>{{ taxYear.year }}</strong> as per W2</label>
                    <div class="wage_documents">
                        <div class="uploadsec_wrap">
                            <div class="w-full">                                 
                                <div class="form_group" @click="uploadMainDocuments = []">
                                    <label class="form_label">Documents</label>
                                    <file-upload
                                        :fileUploadShowingText="'Browse'"
                                        v-model="taxYear.document"
                                        class="file-upload-input mb-0"
                                        style="height: 50px; padding: 0px"
                                        :name="'petitionerTaxDocs' + index"
                                        :multiple="true"
                                        :hideSelected="true"
                                        :accept="allDocEntity"
                                        label="Documents"
                                        :fieldName="'petitionerTaxDocs'+index"  :cid="'petitionerTaxDocs'+index"
                                        :emitCategory="index"  @updateData="updateData" >
                                        <img  class="file-icon" src="@/assets/images/main/file-upload.svg" /> 
                                    </file-upload>
                                    <span class="loader" v-if="false && item.filesAreuploading"
                                        ><img src="@/assets/images/main/loader.gif"
                                    /></span>
                                </div>                                 
                            </div>
                        </div>
                        <ul class="uploaded-list" v-if="checkProperty(taxYear, 'document', 'length') > 0">
                            <template v-for="(fil, fileindex) in taxYear['document']">
                                <vs-chip @click="remove(taxYear['document'], fileindex)" :key="fileindex" closable>
                                    {{ fil.name }}
                                </vs-chip>
                            </template>
                        </ul>
                    </div>
                    <div class="wage-input">
                        <immiInput wrapclass="" :onlyNumbers="true" :allowFloatingPoint="true" :display="false" :cid="'salary'+index" :formscope="formscope" v-model="taxYear.salary" :required="checkProperty(taxYear, 'document', 'length') > 0?true:false" :fieldName="'salary'+index" label="Salary Received($)" placeHolder="Salary Received" />
                    </div>
                </div>
            </template>
        </div>
    </div>        
</template>
<script>
import immiInput from "@/views/forms/fields/simpleinput.vue";
import FileUpload from "@/views/FileUpload.vue";
import _ from "lodash";
export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    props: {
        value: null,
        petition:{
            type:Object,
            default:null
        },
        formscope: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            uploadMainDocuments:[],
        };
    },
    computed: {
    },
    mounted() {
       
    },
    methods: {
        updateData(docs, category){
            let inde = parseInt(category);
            // this.value[inde]['filesAreuploading'] = false
            this.value[inde]['document'] = docs;
            this.uploadMainDocuments = [];
        },
        remove(docList, indx) {
            this.removeFileFromS3(docList[indx])
            docList.splice(indx, 1);
            return false;
        },
    },
    components: {
        FileUpload,
        immiInput,
    }
};
</script>